export default "__VITE_ASSET__DqC31NZ5__"